import React from 'react';
import { Handle, Position } from 'reactflow';
import { HelpCircle } from 'lucide-react';

const MCQNode = ({ data, isConnectable }) => {
  return (
    <div className="px-4 py-2 shadow-md rounded-md bg-white border-2 border-blue-200 node-mcq">
      <div className="flex items-center">
        <HelpCircle className="w-4 h-4 text-blue-600 mr-2" />
        <div className="ml-2">
          <div className="text-lg font-bold text-blue-800">MCQ Generator</div>
          <div className="text-sm text-gray-600">
            {data.config?.concept || 'Multiple Choice Questions'}
          </div>
          <div className="text-xs text-blue-600">
            Count: {data.config?.count || '5'} • Grade: {data.config?.grade || '5'} • {data.config?.language || 'English'}
          </div>
        </div>
      </div>

      <Handle
        type="target"
        position={Position.Top}
        id="input"
        isConnectable={isConnectable}
        className="w-3 h-3 bg-blue-500 border-2 border-white"
      />
      <Handle
        type="source"
        position={Position.Bottom}
        id="output"
        isConnectable={isConnectable}
        className="w-3 h-3 bg-blue-500 border-2 border-white"
      />
    </div>
  );
};

export default MCQNode;